import React from 'react';
import Editor from '@monaco-editor/react';
import { CnSwitch, CnCardSubAreaCard, Box, CnDynamicForm, formilyCore } from '@alife/cn-ui';
import { cloneDeep, isEmpty } from 'lodash-es';
import { InitData, RequestParamsMap } from "../const";
import ParamsArrayForm from "./params-array-form";
import FormatResultForm from "./format-result-form";
import JsExpressionForm from "./js-expression-form";
import "./data-setter.scss";
var createForm = formilyCore.createForm,
  onFieldValueChange = formilyCore.onFieldValueChange,
  onFieldMount = formilyCore.onFieldMount;
var DataSetter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var defaultValue = _ref.defaultValue,
    isFormHook = _ref.isFormHook;
  var dataRef = React.useRef(isEmpty(defaultValue) ? cloneDeep(InitData) : defaultValue);
  var paramsChangeEffects = React.useCallback(function (field, form, isFieldValueChange) {
    if (isFieldValueChange === void 0) {
      isFieldValueChange = false;
    }
    var contentField = field.query('.content').take();

    // 当type是js表达式时，需要渲染特殊的的表单组件
    if (field.value === 'JSEXPN') {
      contentField.setComponent('JsExpressionForm');
    } else {
      var _RequestParamsMap$fie;
      contentField.setComponent('CnInput', {
        placeholder: (_RequestParamsMap$fie = RequestParamsMap[field.value]) === null || _RequestParamsMap$fie === void 0 ? void 0 : _RequestParamsMap$fie.placeholder
      });
    }
    if (isFieldValueChange) {
      contentField === null || contentField === void 0 ? void 0 : contentField.setState({
        value: ''
      });
    }
  }, [isFormHook]);
  var form = React.useMemo(function () {
    return createForm({
      initialValues: isEmpty(defaultValue.asyncData) ? {
        params: {
          array: [{
            value: {
              paramType: Object.keys(RequestParamsMap)[0]
            }
          }]
        }
      } : defaultValue.asyncData,
      effects: function effects() {
        onFieldMount('*(params.array.*.value.paramType)', paramsChangeEffects);

        // 切换参数value类型时，显隐对应配置字段
        onFieldValueChange('*(params.array.*.value.paramType)', function (field, form) {
          return paramsChangeEffects(field, form, true);
        });
      }
    });
  }, []);
  React.useImperativeHandle(ref, function () {
    return {
      getData: function getData() {
        dataRef.current.asyncData = form.getState().values;
        return cloneDeep(dataRef.current);
      }
    };
  });
  if (!Box) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    spacing: 8
  }, !isFormHook && /*#__PURE__*/React.createElement(CnCardSubAreaCard, {
    title: '枚举项回填（使用监听字段的枚举项进行回填）'
  }, /*#__PURE__*/React.createElement(CnSwitch, {
    autoWidth: true,
    defaultChecked: defaultValue.fromDataSource,
    checkedChildren: "\u5DF2\u56DE\u586B",
    unCheckedChildren: "\u4E0D\u56DE\u586B",
    onChange: function onChange(value) {
      dataRef.current.fromDataSource = value;
    }
  })), /*#__PURE__*/React.createElement(CnCardSubAreaCard, {
    title: '静态数据'
  }, /*#__PURE__*/React.createElement(Editor, {
    height: '150px',
    defaultLanguage: "json",
    roundedSelection: false,
    scrollBeyondLastLine: false,
    tabSize: 2,
    defaultValue: defaultValue.syncData,
    onChange: function onChange(value) {
      dataRef.current.syncData = value;
    }
  })), /*#__PURE__*/React.createElement(CnCardSubAreaCard, {
    title: '接口配置'
  }, /*#__PURE__*/React.createElement(CnDynamicForm, {
    cols: 5,
    form: form,
    components: {
      ParamsArrayForm: ParamsArrayForm,
      FormatResultForm: FormatResultForm,
      JsExpressionForm: JsExpressionForm
    },
    schema: [{
      title: '请求URL',
      name: 'url',
      component: 'CnInput',
      colSpan: '4'
    }, {
      title: '请求方法',
      name: 'method',
      component: 'CnAsyncSelect',
      "default": 'POST',
      colSpan: '1',
      "enum": [{
        label: 'POST',
        value: 'POST'
      }, {
        label: 'GET',
        value: 'GET'
      }]
    }, {
      title: '入参配置',
      name: 'params',
      component: 'ParamsArrayForm',
      'component-props': {
        name: 'array',
        isFormHook: isFormHook
      },
      colSpan: 'full'
    }, {
      title: '出参配置',
      name: 'formatResult',
      component: 'FormatResultForm',
      "default": 'function formatResult (res){\n    // 对接口数据进行自定义format\n    return res.data\n}',
      colSpan: 'full'
    }]
  })));
});
DataSetter.defaultProps = {
  defaultValue: {}
};
export default DataSetter;